
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRotSector as ObcRotSectorElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rot-sector/rot-sector.js';
 
 
 

 
 export const ObcRotSector = createComponent({
   react: React,
   tagName: 'obc-rot-sector',
   elementClass: ObcRotSectorElement,
   events: {
     
   }
  });
 
 